import { isArray, isPlainObject } from 'lodash';

import type { ImmutableJSObject } from './isImmutable';
import { isImmutable } from './isImmutable';
import type { JSONArray, JSONObject } from './json';

export const isJSONValue = (v: unknown): v is JSONObject | JSONArray | ImmutableJSObject =>
  isPlainObject(v) || isArray(v) || isImmutable(v);

export const isPlainJSONObject = (v: unknown): v is JSONObject => isPlainObject(v);
